export const domainName = window.location.hostname;
export const apiBaseUrl = "http://104.236.226.98/v1/";
export const apiBaseUrlLocal = "https://buyback-api.palletiq.com/v1/";
